import { coins, ledgerApps } from "../constants";
import { getPubKeyStr } from "../lib/tendermint";

const validLedgers = Object.keys(ledgerApps);

const Account = (ledger, path, accountPayload) => {
  const getAddress = async () => {
    const { address, pubkey } = await ledger.getAddress(path, accountPayload);
    if (pubkey) return { address, pubkey, pubkeyStr: getPubKeyStr(pubkey) };
    return { address };
  };
  const getPubKey = async () => {
    return ledger.getPubKeyEncoded(path, accountPayload);
  };
  const signTransaction = async (rawTx) => {
    return ledger.signTransaction(path, rawTx, accountPayload);
  };
  const sign = async (message) => {
    return ledger.sign(path, message);
  };
  const verifySignature = async (message, signature) => {
    return ledger.verifySignature(path, message, signature);
  };

  return {
    getAddress,
    getPubKey,
    sign,
    signTransaction,
    verifySignature,
  };
};

const Backend = ({ ledger, coinName }) => {
  const genAccount = async (ledger, hdPath, accountPayload) => {
    const { coinNum, accountNum, changeNum, addressIdx, ...rest } =
      accountPayload;
    const path =
      "string" === typeof hdPath ? convertPathStringToArray(hdPath) : hdPath;
    return Account(ledger, path, rest);
  };

  const getAccount = async (
    { hdPath, accountNum, addressIdx } = { addressIdx: 0 }
  ) => {
    const accountPayload = { ...coins[coinName], addressIdx };
    accountPayload.accountNum =
      accountNum !== undefined ? accountNum : accountPayload.accountNum;
    return genAccount(ledger, hdPath, accountPayload);
  };

  const cleanUp = async () => {};

  return {
    getAccount,
    cleanUp,
  };
};

const convertPathStringToArray = (path) =>
  path.replace(/'|m\//g, "").split("/").map(Number);

Backend.create = async ({
  coinName,
  skipFailsThreshold = false,
  appName,
} = {}) => {
  appName = appName || coinName;
  if (validLedgers.indexOf(appName) === -1)
    throw Error(`Ledger: ${appName} not supported`);
  const ledger = ledgerApps[appName]();
  await ledger.connect({ skipFailsThreshold });
  return Backend({ ledger, coinName });
};

export default Backend;
